export default __webpack_public_path__ + "static/media/List-documentation.70c6a857.md";